var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_465)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_465",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3945 12.1944C10.4943 13.0946 9.27326 13.6004 8.00011 13.6004C6.72697 13.6004 5.50596 13.0946 4.60571 12.1944C3.70546 11.2941 3.19971 10.0731 3.19971 8.79999C3.19971 7.52685 3.70546 6.30584 4.60571 5.40559C4.60571 7.19999 4.80011 8.79999 7.20011 9.59999C7.20011 7.99999 8.00011 3.19999 9.20011 2.39999C10.0001 3.99999 10.4569 4.46879 11.3937 5.40559C11.8402 5.85081 12.1944 6.37989 12.4357 6.96242C12.6771 7.54495 12.8009 8.16944 12.8001 8.79999C12.801 9.43048 12.6772 10.0549 12.436 10.6375C12.1948 11.22 11.8409 11.7491 11.3945 12.1944Z",
    fill: "#09090B",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3033 12.0968C6.52469 12.326 6.78952 12.5089 7.08233 12.6346C7.37514 12.7604 7.69006 12.8266 8.00873 12.8294C8.32741 12.8322 8.64344 12.7714 8.93839 12.6508C9.23334 12.5301 9.5013 12.3519 9.72665 12.1265C9.95199 11.9012 10.1302 11.6332 10.2509 11.3383C10.3715 11.0433 10.4323 10.7273 10.4295 10.4086C10.4267 10.09 10.3605 9.77504 10.2347 9.48223C10.109 9.18942 9.92612 8.92459 9.6969 8.7032C9.2289 8.2344 9.0001 8 8.6001 7.2C8.0001 7.6 7.6001 10 7.6001 10.8C6.3033 10.8 5.6001 10.4 5.6001 10.4C5.6001 11.0144 5.8345 11.6288 6.3033 12.0968Z",
    fill: "#09090B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/Fire.ad010133da919d62b9d918e5f3531332.svg";
export { ForwardRef as ReactComponent };